var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [
        _vm.organizationUnitId
          ? _c("AdminNavigationV2", { attrs: { tid: _vm.organizationUnitId } })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Manage user's details")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: { href: `/#/admin/organizations/users/manage/${_vm.id}` },
            },
            [
              _c("i", {
                staticClass: "fa fa-arrow-left",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Back")]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("h3", { staticClass: "fg-color-blue" }, [
        _vm._v("User " + _vm._s(_vm.email)),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "FirstName" } }, [_vm._v("First name:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputFirstName,
                expression: "inputFirstName",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "First name of an user" },
            domProps: { value: _vm.inputFirstName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputFirstName = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "FirstName", errors: _vm.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "LastName" } }, [_vm._v("Last name:")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputLastName,
                expression: "inputLastName",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Last name of an user" },
            domProps: { value: _vm.inputLastName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputLastName = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "LastName", errors: _vm.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "DisplayName" } }, [
            _vm._v("Display name:"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputDisplayName,
                expression: "inputDisplayName",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Display name of an user" },
            domProps: { value: _vm.inputDisplayName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.inputDisplayName = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c("ValidationError", {
            attrs: { context: "DisplayName", errors: _vm.validationErrors },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.statusInitial || _vm.statusInvalid,
              expression: "statusInitial || statusInvalid",
            },
          ],
          staticClass: "btn btn-primary btn-lg",
          attrs: { type: "button" },
          on: { click: _vm.handleUpdateUserDetailsCommandV1 },
        },
        [_vm._v("Update")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.statusInvoking,
              expression: "statusInvoking",
            },
          ],
          staticClass: "btn btn-primary btn-lg",
          attrs: { type: "button", disabled: "" },
        },
        [_vm._v("Updating...")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }